import apiService from '@/services/apiService'

// Backfill automatizado de imágenes de catálogo — ver
// SPEC/PLAN/TASKS_BACKFILL_IMAGENES_CATALOGO_v0.1.md en ecommerce-graciela/docs.
export default {
  async getAudit() {
    const { data } = await apiService.get('/api/products/images/audit')
    return data
  },
  async getStatus() {
    const { data } = await apiService.get('/api/products/images/backfill/status')
    return data
  },
  async runBatch(batchSize) {
    const { data } = await apiService.post('/api/products/images/backfill/run', { batch_size: batchSize })
    return data
  },
  async cancelBatch() {
    const { data } = await apiService.post('/api/products/images/backfill/cancel')
    return data
  },
}
